<template>
  <div id="footer" ref="footer" class="container-fluid">
    <!-- <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div> -->
    <!-- <p class="title">公司企业网站模板</p> -->
    <p class="address_tel_fax">
      <span>广州业务总部地址：广东省广州市番禺区南大干线敏捷华美国际1栋414室；</span>
      <span>联系电话：15706680000</span>
    </p>
    <p class="email_wx">
       <span>茂名行政总部地址：广东省茂名市茂南区香塘一街长湖3号大院22号楼；</span>
      <span>联系电话：15706680000</span>
     <p class="copy">Copyright &copy; 广东三里行智能科技股份有限公司</p>
      
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {
    containerClassName: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {};
  },
  mounted() {
    //vue中获取节点距离底部的距离

  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  bottom: 0px;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
  text-align: left;
  width: 80%;
  margin: 20px auto;

}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
   width: 80%;
    margin: 20px auto;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  text-align:center
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue